<!--<template>
    <button>
        <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
    </button>
</template> -->
 
<script>

export default{
    data(){
        return {
            path:`<path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>`,
            svg: `<svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                     <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                 </svg>`
        }
    },
   props:['wrapcontentwithbutton'],
    render(h) {
        if(!this.wrapcontentwithbutton || this.wrapcontentwithbutton == false)
            return h('svg',{
                 class: 'bi bi-x',
                 domProps:{innerHTML:this.path},
                 attrs:{
                    width:'2em',
                    height:'1.5em',
                    viewBox:'0 0 16 16',
                    fill:'currentColor',
                    xmlns:'http://www.w3.org/2000/svg',
                 },
                 on: this.$listeners,
          });
        return h('button', {domProps:{innerHTML:this.svg}})
    }
}

</script>

<style lang="scss" scoped>
svg{
    color: #939393;
}

svg:hover{
    color: #eee !important;
}

button,span{
    width:auto;
    height: auto;
    display: inherit;
}

</style>